import React, {Component} from 'react';
import Action from 'components/organisms/used-players-list/actions';
import InputRadio from 'components/atoms/inputs/input-radio';
import {
    createOverallFilterPosition,
    FilterPosition,
    isOverallFilterPosition,
} from 'components/organisms/filter-by-position/filter-position-interface';
import Const from 'constants';

class BaseFilterComponent extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('FilterPosition', value));
    }

    getPositionTab(params) {
        const {value, title, isChecked} = params;

        return (
            <label className="tabs-chk" key={value.getKey()}>
                <InputRadio value={value} checked={isChecked} onChange={::this.onChange} />
                <span>{title}</span>
            </label>
        );
    }

    prepareTabs() {
        const {sportConfig, filters, modesConfig} = this.props;
        const cptConfig = modesConfig.getConfig('CPT');

        const tabs = [
            this.getPositionTab({
                value: createOverallFilterPosition(),
                title: 'All',
                isChecked: isOverallFilterPosition(filters.position),
            }),
            this.getPositionTab({
                value: new FilterPosition(Const.CAPTAIN_MODE, [Const.CAPTAIN_MODE]),
                title: cptConfig.getLabel(),
                isChecked: filters.position.isKeyEqual(Const.CAPTAIN_MODE),
            }),
        ];

        const positions = sportConfig.getFilter('positions', []);

        positions.map((position) => {
            tabs.push(
                this.getPositionTab({
                    value: new FilterPosition(position.key, Object.values(position.map), position.map),
                    title: position.key,
                    isChecked: filters.position.isKeyEqual(position.key),
                }),
            );
        });

        return tabs;
    }
}

export {BaseFilterComponent};
